export const injectBearer = (tokenString: string): string =>
  tokenString && tokenString.includes('Bearer')
    ? tokenString
    : `Bearer ${tokenString}`

export const removeBearer = (tokenString: string): string =>
  tokenString ? tokenString.replace(/^Bearer /, '') : tokenString
